import React, { useEffect } from "react";
import { connect } from "react-redux";
import AutoRefreshPeriscope from "./AutoRefreshPeriscope";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SatismeterService from "../../services/SatismeterService";

const MainHeader = ({ classname = "", headerText = "" }) => {
	const location = useLocation();
	useEffect(() => {
		if (location.pathname.startsWith("/periscope/")) {
			SatismeterService.satismeterEvent("periscopeModuleAccessed");
		}
	}, []);
	return (
		<div className={classname}>
			<div className="title-peri"> {headerText} </div>
			<AutoRefreshPeriscope />
		</div>
	);
};

const mapStateToProps = (state) => ({
	periscopeDataResponse: state.periscopeDataResponse
});

export default connect(mapStateToProps)(MainHeader);
